import HTTPClient from '@/common/http-client';
import { ScanConfirmRequest } from '@/tsort/model/request/scan-confirm-request.model';
import { ScanConfirmResponse } from '@/tsort/model/response/scan-confirm-response.model';
import { CancelTaskResponse } from '@/tsort/model/response/cancel-task-response.model';
import { ResultResponse } from '@/common/model/response/general-response.model';
import { CancelTaskRequest } from '@/tsort/model/request/cancel-task-request.model';
import { ErrorResponse } from '@/common/model/response/error-response.model';
import { CreateBatchRequest } from '@/tsort/model/request/create-batch-request.model';
import { GetTargetTaskRequest } from '@/tsort/model/request/get-target-task-request.model';
import { GetTaskResponse } from '@/tsort/model/response/get-task-response.model';
import { ResetLockRequest } from '@/tsort/model/request/reset-lock-request.model';
import BaseService from '@/common/service/base.service';
import { ScanSystemMenuResponse } from '@/tsort/model/response/scan-system-menu-response.model';
import { DeleteBatchEmptyTask } from '@/tsort/model/request/delete-batch-empty-task-request.model';
import { CreateBatchResponse } from '@/tsort/model/response/create-batch-response.model';
import { LogSingleRequest } from '@/tsort/model/request/log-single-request';
import StringUtils from '@/common/utils/string.util';
import { ScanSettingResponse } from '@/tsort/model/response/scan-setting-response.model';
const SCAN_CONFIRM_URL = `/func/send-scan-data/scan-confirm-v2`;
const CREATE_BATCH_URL = `/func/create-batch`;
const CANCE_TASK_URL = `/func/cancel-task`;
const GET_TARGET_TASK_URL = `/func/send-scan-data/get-target-task-v2`;
const RESET_LOCK_URL = `/func/send-scan-data/reset-lock`;
const GET_SCAN_SYSTEM_FIELD = `/func/get-scan-system-field-v2`;
const DELETE_BATCH_EMPTY_TASK = `/func/delete-empty-batch`;
const LOG_WARN_REGIST = '/log/regist/warn';
const GET_SCAN_SETTING = `/func/get-scan-setting`;

export default class SortingService extends BaseService {
  // Scan Confirm
  public async putScanConfirm(
    singleSortingRequest: ScanConfirmRequest,
    isDelayMsg = false
  ): Promise<ScanConfirmResponse | undefined> {
    const axios = isDelayMsg ? this.HTTP_WITH_DELAYED_MSG : this.HTTP;
    const axiosResponse = await axios.put<ScanConfirmResponse | undefined>(SCAN_CONFIRM_URL, singleSortingRequest);
    const dataResponse = HTTPClient.convertAxiosResponseToResponse(axiosResponse);
    return dataResponse;
  }

  public async getScanSystemField(): Promise<Array<ScanSystemMenuResponse>> {
    const axiosResponse = await this.HTTP.get<Array<ScanSystemMenuResponse>>(GET_SCAN_SYSTEM_FIELD);
    const dataResponse = HTTPClient.convertAxiosResponseToResponse(axiosResponse);
    return dataResponse;
  }

  // Create Batch
  public async postCreateBatch(createBatchRequest: CreateBatchRequest): Promise<CreateBatchResponse> {
    const axiosResponse = await this.HTTP.post<CreateBatchResponse>(CREATE_BATCH_URL, createBatchRequest);
    const dataResponse = HTTPClient.convertAxiosResponseToResponse(axiosResponse);
    return dataResponse;
  }

  // Cancel Task
  public async putCancelTask(cancelTaskRequest: CancelTaskRequest): Promise<CancelTaskResponse | ErrorResponse> {
    const axiosResponse = await this.HTTP.put<CancelTaskResponse | ErrorResponse>(CANCE_TASK_URL, cancelTaskRequest);
    const dataResponse = HTTPClient.convertAxiosResponseToResponse(axiosResponse);
    return dataResponse;
  }
  // Get Target Task
  async putGetTargetTask(getTargetTask: GetTargetTaskRequest): Promise<GetTaskResponse> {
    const axiosResponse = await this.HTTP.put<GetTaskResponse>(GET_TARGET_TASK_URL, getTargetTask);
    const dataResponse = HTTPClient.convertAxiosResponseToResponse(axiosResponse);
    return dataResponse;
  }
  // Reset Lock
  async putResetLock(resetLock: ResetLockRequest): Promise<ResultResponse | null> {
    const axiosResponse = await this.HTTP.put<ResultResponse | null>(RESET_LOCK_URL, resetLock);
    const dataResponse = HTTPClient.convertAxiosResponseToResponse(axiosResponse);
    return dataResponse;
  }

  // delete batch empty task
  async deleteBatchEmptyTask(deleteBatchEmptyTask: DeleteBatchEmptyTask): Promise<ResultResponse | null> {
    const axiosResponse = await this.HTTP.delete<ResultResponse | null>(DELETE_BATCH_EMPTY_TASK, {
      data: deleteBatchEmptyTask
    });
    const dataResponse = HTTPClient.convertAxiosResponseToResponse(axiosResponse);
    return dataResponse;
  }

  /**
   * 警告ログの登録を行います。
   *
   * @param scanCode スキャンコード
   * @param requestParams リクエストパラメータ
   * @param logMsg ログーメッセージ
   * @param errCd エラーコード
   * @returns Promise<void>
   */
  async addLogWarn(logMsgParamList: Array<string>, logMsg: string, category: number): Promise<ResultResponse | null> {
    // LogSingleRequestオブジェクトの初期化
    let dataRequest = {} as LogSingleRequest;

    // LogSingleRequestに値を設定
    dataRequest = {
      category,
      message: StringUtils.buildMsg(logMsgParamList, logMsg)
    };

    // ソートサービスを使用して警告ログを登録
    const axiosResponse = await this.HTTP.post<ResultResponse | null>(LOG_WARN_REGIST, dataRequest);
    const dataResponse = HTTPClient.convertAxiosResponseToResponse(axiosResponse);
    return dataResponse;
  }

  /**
   * スキャン設定を取得する非同期メソッドです。
   *
   * @returns Promise<ScanSettingResponse>
   */
  public async getScanSetting(): Promise<ScanSettingResponse> {
    const axiosResponse = await this.HTTP.get<ScanSettingResponse>(GET_SCAN_SETTING);
    const dataResponse = HTTPClient.convertAxiosResponseToResponse(axiosResponse);
    return dataResponse;
  }
}
